module.exports = __webpack_public_path__ + "img/biking.069de4a7.svg";